import React, { useState } from "react";
import axios from "axios";
import { API, useApp, WHATSAPP_URL } from "../store";
import { Mail, MapPin, Phone, MessageCircle, Headset } from "lucide-react";

export default function Contact() {
  const { t } = useApp();
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [ok, setOk] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    await axios.post(`${API}/contact`, form);
    setOk(true); setForm({ name: "", email: "", phone: "", message: "" });
  };

  const openLiveAgent = () => {
    const el = document.querySelector("[data-testid='floating-chat-btn']");
    if (el) el.click();
  };

  return (
    <main className="pt-32 pb-32 bg-white min-h-screen" data-testid="contact-page">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-16">
        <div>
          <div className="overline mb-4">{t.contact.overline}</div>
          <h1 className="font-serif-display text-5xl md:text-7xl text-slate-900">{t.contact.title}</h1>
          <p className="text-slate-600 mt-6 max-w-md">{t.contact.body}</p>

          <div className="mt-8 flex flex-wrap gap-3">
            <button onClick={openLiveAgent} className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-sky-500 hover:bg-sky-600 text-white text-sm font-ui font-semibold uppercase tracking-wider transition-colors" data-testid="contact-live-agent">
              <Headset size={16} /> {t.contact.live}
            </button>
            <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-emerald-500 hover:bg-emerald-600 text-white text-sm font-ui font-semibold uppercase tracking-wider transition-colors" data-testid="contact-whatsapp">
              <MessageCircle size={16} /> {t.contact.whatsapp}
            </a>
          </div>

          <div className="mt-10 space-y-4 text-slate-700">
            <div className="flex items-start gap-3"><Mail size={18} className="text-sky-500 mt-1" /> sales@sharkxelectric.com</div>
            <div className="flex items-start gap-3"><Phone size={18} className="text-sky-500 mt-1" /> +351 912 345 678</div>
            <div className="flex items-start gap-3"><MapPin size={18} className="text-sky-500 mt-1" /> Florianópolis · Brazil</div>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-4 bg-slate-50 border border-slate-200 rounded-md p-8" data-testid="contact-form">
          <input required placeholder={t.contact.name} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full bg-white border border-slate-300 px-5 py-4 rounded-md focus:border-sky-500 focus:outline-none" data-testid="contact-name" />
          <input required type="email" placeholder={t.contact.email} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full bg-white border border-slate-300 px-5 py-4 rounded-md focus:border-sky-500 focus:outline-none" data-testid="contact-email" />
          <input type="tel" placeholder={t.contact.phone} value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="w-full bg-white border border-slate-300 px-5 py-4 rounded-md focus:border-sky-500 focus:outline-none" data-testid="contact-phone" />
          <textarea required rows={6} placeholder={t.contact.msg} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="w-full bg-white border border-slate-300 px-5 py-4 rounded-md focus:border-sky-500 focus:outline-none" data-testid="contact-msg"></textarea>
          <button className="btn-primary !justify-center w-full" data-testid="contact-submit">{t.contact.cta}</button>
          {ok && <div className="text-sky-600 font-ui uppercase tracking-widest text-sm" data-testid="contact-ok">✓ {t.contact.ok}</div>}
        </form>
      </div>
    </main>
  );
}
